import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loader2, ScrollText } from "lucide-react";

const fmt = (iso) => {
  try { return new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }); }
  catch { return iso; }
};

const ACTION_STYLE = (a = "") => {
  if (a.includes("delete")) return "border-rose-500/40 bg-rose-500/10 text-rose-300";
  if (a.includes("login")) return "border-sky-500/40 bg-sky-500/10 text-sky-300";
  if (a.includes("role") || a.includes("status")) return "border-amber-500/40 bg-amber-500/10 text-amber-300";
  if (a.includes("content")) return "border-violet-500/40 bg-violet-500/10 text-violet-300";
  return "border-slate-600 bg-slate-700/40 text-slate-300";
};

export default function AdminAudit() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/api/admin/audit?limit=200").then(({ data }) => setItems(data.items)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="admin-audit-page">
      <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.18em] text-[#5ec0ff] font-semibold mb-1">
        <ScrollText className="w-3.5 h-3.5" /> Audit log
      </div>
      <h1 className="text-2xl font-bold text-white">Recent activity</h1>
      <p className="text-sm text-slate-400 mt-1">Auth, admin and content events — newest first.</p>

      <div className="mt-6 rounded-xl border border-slate-800 bg-[#0e1726] overflow-hidden">
        {items === null ? (
          <div className="flex items-center justify-center gap-2 text-slate-500 text-sm py-16">
            <Loader2 className="w-4 h-4 animate-spin" /> Loading audit log…
          </div>
        ) : items.length === 0 ? (
          <div className="text-center text-slate-500 py-16 text-sm">No audit events yet.</div>
        ) : (
          <div className="divide-y divide-slate-800" data-testid="admin-audit-list">
            {items.map((r) => (
              <div key={r.id} className="flex flex-wrap items-center gap-3 px-4 py-2.5" data-testid={`audit-row-${r.id}`}>
                <span className="text-[11px] text-slate-500 w-28 shrink-0 font-mono-clinical">{fmt(r.ts)}</span>
                <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full border ${ACTION_STYLE(r.action)}`}>
                  {r.action}{r.status === "failure" ? " · failed" : ""}
                </span>
                <span className="text-sm text-slate-300 truncate flex-1 min-w-0">
                  {r.actor_email || "—"}
                  {r.target_id ? <span className="text-slate-500"> → {r.target_type}:{r.target_id}</span> : null}
                </span>
                {r.ip && <span className="text-[11px] text-slate-600 hidden sm:inline">{r.ip}</span>}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
